import {
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  Skeleton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import UploadFile from "../../components/common/UploadFile/uploadFile";
import { useEffect, useState } from "react";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import MUIDataTable from "mui-datatables";

import FileState from "../../components/common/fileState";
import LoopIcon from "@mui/icons-material/Loop";
import { useSelector } from "react-redux";
import { getUser } from "../userSlice";
import { NoInfoComponent } from "../../components/common/NoInfoImage/noInfoComponent";
import ModalInfoTraders from "../../components/common/Modals/modalInfoTraders";
import CustomTablePagination from "../../components/DataTable/CustomTablePagination";
import {
  GetEmployees,
  UploadEmployeesFile,
} from "../../services/user/infonavit/infonavitEmployees";
import { CODES } from "../../consts/codes";
import fileDownload from "js-file-download";
import { decode } from "base64-arraybuffer";
import {
  DownloadCatalogErrorLog,
  DownloadCatalogueFile,
} from "../../services/user/catalogueService";
import { stringToDateTimeString } from "../../utils/functions";

export const UploadEmployees = () => {
  /**
   * Use Translation
   */
  const { t, i18n } = useTranslation();

  /**
   * Use Selector
   */
  const userInfo = useSelector(getUser);

  /**
   * Use State
   */
  //Data de grilla
  const [data, setData] = useState([]);

  //Archivo seleccionado
  const [fileSelected, setFileSelected] = useState(null);

  //Carga de tabla o refrescar
  const [isLoadingData, setIsLoadingData] = useState(false);

  //Modal respuesta carga archivo
  const [isOpenModalResponse, setIsOpenModalResponse] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState({
    data: { responseMessage: "" },
  });
  //Si hay archivos cargados o no
  const [isMastersUploaded, setIsMastersUploaded] = useState(false);

  /**
   * Use Effect
   */
  /**
   * Lista los archivos cargados
   */
  useEffect(() => {
    if (userInfo) {
      fetchData();
    }
  }, [userInfo]);

  /**
   * Configuración para las columnas de la tabla
   */
  const columns = [
    {
      name: "startDate",
      label: t("App.catalogue.table.startDate"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return stringToDateTimeString(Date.parse(value));
        },
      },
    },
    {
      name: "endDate",
      label: t("App.catalogue.table.endDate"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return stringToDateTimeString(Date.parse(value));
        },
      },
    },
    {
      name: "user",
      label: t("App.catalogue.table.user"),
      options: {
        filter: true,
        sort: true,
        searchable: true,
      },
    },
    {
      name: "cantEmployees",
      label: t("App.infonavitMasters.table.cantEmployees"),
      options: {
        filter: true,
        sort: true,
        searchable: true,
      },
    },

    {
      name: "file",
      label: t("App.catalogue.table.file"),
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <FormControlLabel
            label=""
            value={value.fileName}
            control={
              <a
                className="default-text__linkBlue__sm"
                onClick={(event) =>
                  handleDownloadFile(value.fileName, value.pathFileName)
                }
              >
                {value.fileName}
              </a>
            }
            onChange={(event) => updateValue(event.target.value)}
          />
        ),
      },
    },
    {
      name: "state",
      label: t("App.traders.table.state"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <FileState
            value={value}
            onChange={(event) => updateValue(event.target.value)}
          />
        ),
      },
    },
    {
      name: "errors",
      label: t("App.catalogue.table.errors"),
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <FormControlLabel
            label=""
            value={value}
            control={
              value.awsUploadLog ? (
                <a
                  className="default-text__linkBlue__sm"
                  onClick={(event) => {
                    setModalTitle(t("App.validationMessages.error"));
                    setModalContent({
                      status: 500,
                      data: {
                        responseMessage: t(
                          "App.validationMessages.systemError2"
                        ),
                      },
                    });
                    setIsOpenModalResponse(true);
                  }}
                >
                  ERROR
                </a>
              ) : (
                <a
                  className="default-text__linkBlue__sm"
                  onClick={(event) =>
                    handleDownloadLog(value.logFileName, value.pathLogFileName)
                  }
                >
                  {value.logFileName}
                </a>
              )
            }
            onChange={(event) => updateValue(event.target.value)}
          />
        ),
      },
    },
  ];

  /**
   * Opciones para la configuración de la tabla
   */
  const options = {
    filterType: "dropdown",
    download: false,
    print: "false",
    selectableRows: "none",
    responsive: "standard",
    searchPlaceholder: t("App.catalogue.table.searchPlaceholder"),
    elevation: 0,
    viewColumns: false,
    search: false,
    filter: false,
    searchOpen: true,
    rowsPerPageOptions: [10, 15, 20],
    textLabels: {
      body: {
        noMatch: isLoadingData ? (
          <Skeleton />
        ) : (
          <NoInfoComponent type="dynamic" text="" />
        ),
        toolTip: "Sort",

        columnHeaderTooltip: (column) =>
          t("App.buttonLabels.order", { label: column.label }),
      },
      pagination: {
        next: t("App.userDetail.next"),
        previous: t("App.userDetail.previous"),
        rowsPerPage: t("App.userDetail.resultsPerPage"),
        displayRows: t("App.userDetail.of"),
      },
    },
  };

  /**
   * Handles
   */
  /**
   * Trae la información de los archivos
   */
  const fetchData = async () => {
    try {
      setData([]);
      setIsLoadingData(true);

      const {
        status,
        data: { responseStatus, response },
      } = await GetEmployees(userInfo?.mainUser, userInfo?.idRole);

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseStatus.statusCode === CODES.S_COD_RESPONSE_SUCCESS_REQUEST
      ) {
        setIsMastersUploaded(response.length > 0);
        const finalData = setDataStructure(response);
        setData(finalData);
      } else {
        setIsMastersUploaded(false);
      }
      setIsLoadingData(false);
    } catch (error) {
      setIsLoadingData(false);
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  /**
   *
   * Función para descargar los archivos cargados
   *
   * @param {String} fileName nombre del archivo
   * @param {String} pathFileName path del archivo
   */
  const handleDownloadFile = async (fileName, pathFileName) => {
    try {
      const obj = {
        pathFileName,
        fileName,
      };

      const {
        status,
        data: { responseCode, responseMessage, data },
      } = await DownloadCatalogueFile(obj);

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseCode === CODES.COD_RESPONSE_HTTP_OK
      ) {
        fileDownload(decode(data.fileContent), data.fileName);
      } else {
        setModalTitle(handleSetTitle(responseCode));
        setModalContent({
          status: status,
          data: {
            responseMessage,
            responseCode,
          },
        });
        setIsOpenModalResponse(true);
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  /**
   *
   * Función para descargar los archivos cargados (detalle de errores/log)
   *
   * @param {String} logFileName nombre del archivo log
   * @param {String} pathLogFileName path del archivo
   */
  const handleDownloadLog = async (logFileName, pathLogFileName) => {
    try {
      const obj = {
        pathLogFileName: pathLogFileName,
        logFileName: logFileName,
      };
      const {
        status,
        data: { responseCode, responseMessage, data },
      } = await DownloadCatalogErrorLog(obj);

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseCode === CODES.COD_RESPONSE_HTTP_OK
      ) {
        fileDownload(decode(data.fileContent), data.fileName);
      } else {
        setModalTitle(handleSetTitle(responseCode));
        setModalContent({
          status: status,
          data: {
            responseMessage,
            responseCode,
          },
        });
        setIsOpenModalResponse(true);
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  /**
   * Función que carga el archivo elegido a la plataforma
   */
  const handleUploadFile = async () => {
    try {
      const obj = {
        fileContent: fileSelected[0],
        fileName: `${stringToDateTimeString(new Date())}_${
          fileSelected[0].name
        }`,
        rfc: userInfo.company.eanCompany,
        mainUser: userInfo.mainUser,
        user: userInfo.email,
        country: "CO",
      };

      const {
        status,
        data: { responseStatus, response },
      } = await UploadEmployeesFile(obj);

      setFileSelected(null);
      setModalTitle(
        handleSetTitle(
          responseStatus.statusCode,
          response?.detailMessage ?? false
        )
      );
      setModalContent({ data: { responseStatus, response }, status });

      setIsOpenModalResponse(true);
      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseStatus.statusCode === CODES.S_COD_RESPONSE_SUCCESS_REQUEST
      ) {
        await fetchData();
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  /**
   * Retorna el título correspondiente del modal según el responseCode
   * @param {*} responseCode código de respuesta
   * @returns título del modal
   */
  const handleSetTitle = (responseCode, custom = false) => {
    if (custom) {
      const lang = i18n?.resolvedLanguage ?? i18n?.language;
      return custom[`message${lang.toUpperCase()}`] ?? "Error";
    }

    switch (responseCode) {
      case CODES.S_COD_RESPONSE_SUCCESS_REQUEST:
      case CODES.COD_RESPONSE_SUCCESS:
        return t("App.infonavitMasters.modal.uploadSuccess");
      default:
        return t("App.validationMessages.error");
    }
  };

  /**
   * Aplica la estructura de tabla a los datos entrantes
   * @param {*} fileList lista de archivos cargados
   * @returns lista de de archivos formateada
   */
  const setDataStructure = (fileList) => {
    return fileList.map((file, i) => {
      return {
        startDate: file?.initialUploadingDate ?? "  ",
        endDate: file?.finalUploadingDate ?? "  ",
        user: file?.user ?? "  ",
        cantEmployees: file?.employeesNumber ?? "  ",
        file: file?.fileName
          ? {
              fileName: file.fileName,
              pathFileName: file.filePath,
            }
          : "  ",
        state: file?.state ?? "  ",
        errors: file.awsUploadLog
          ? {
              awsUploadLog: file.awsUploadLog,
            }
          : {
              logFileName: file.logFileName,
              pathLogFileName: file.pathLogFileName,
            },
      };
    });
  };

  return (
    <Grid
      container
      gap="2rem"
      padding={{
        xs: "2rem",
        sm: "3rem 2.5rem",
        md: "3rem 2.5rem",
        lg: "2.6rem 4.5rem",
        xl: "3rem 14.25rem",
      }}
    >
      <Grid item xs="12" marginBottom="3rem">
        <p className="display-large__primary-one">
          {t("App.infonavitMasters.title")}
        </p>
      </Grid>

      <Grid item xs="12">
        <Grid
          container
          direction="column"
          rowSpacing={2}
          className="full-width"
          padding="1.5rem"
          paddingTop="0"
          borderRadius="16px"
          style={{ backgroundColor: "white" }}
        >
          <Grid item>
            <Grid
              container
              columnSpacing={1}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                {" "}
                <FileUploadOutlinedIcon className="accordion__upload__uploadIcon" />
              </Grid>
              <Grid item className="display-small__primary-one">
                {" "}
                {t("App.infonavitMasters.uploadHeader")}
              </Grid>
            </Grid>
          </Grid>

          <Grid item className="full-width">
            <UploadFile
              dragText={t("App.infonavitMasters.dragging")}
              handleUploadFile={handleUploadFile}
              fileSelected={fileSelected}
              setFileSelected={setFileSelected}
              setErrorModal={(value) => {
                setModalContent({
                  status: CODES.COD_RESPONSE_HTTP_ERROR,
                  data: { responseMessage: "" },
                });

                setIsOpenModalResponse(value);
              }}
              setErrorTitle={setModalTitle}
              customValidation={{
                allowedSize: 500000,
                allowedTypes: ["txt"],
                requirements: t("App.infonavitMasters.requirements"),
                requirementsAdvice: t(
                  "App.infonavitMasters.requirementsAdvice"
                ),
              }}
            />
          </Grid>
          {isMastersUploaded && (
            <Grid item className="full-width">
              <Grid
                container
                justifyContent={"flex-end"}
                alignItems={"center"}
                columnSpacing={2}
                rowSpacing={2}
                textAlign={"center"}
              >
                <Grid
                  lg={"auto"}
                  sm={"auto"}
                  xs={12}
                  item
                  className="download-explanation"
                >
                  {t("App.rateMaster.refresh")}
                </Grid>
                <Grid lg={"auto"} sm={"auto"} xs={12} item>
                  <Button
                    disableRipple
                    disabled={isLoadingData ? true : false}
                    startIcon={!isLoadingData ? <LoopIcon /> : <></>}
                    className="btn__outlined__blue full-width"
                    onClick={fetchData}
                  >
                    {!isLoadingData ? (
                      t("App.catalogue.update")
                    ) : (
                      <CircularProgress size={23} color="inherit" />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item>
            <Grid
              container
              columnSpacing={1}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                {" "}
                <TableChartOutlinedIcon className="accordion__upload__tableIcon" />
              </Grid>
              <Grid item className="display-small__primary-one">
                {" "}
                {t("App.salesForce.subtitle")}
              </Grid>
            </Grid>
          </Grid>

          <Grid item className="full-width">
            <MUIDataTable
              style={{ width: "100% !important" }}
              components={{
                TableFooter: (props) => (
                  <CustomTablePagination paginationProps={props} />
                ),
              }}
              data={data}
              columns={columns}
              options={options}
              className="dataTable__base"
            />
          </Grid>

          <ModalInfoTraders
            title={modalTitle}
            responseData={modalContent}
            open={isOpenModalResponse}
            onClose={() => {
              setIsOpenModalResponse(false);
            }}
            currentMaster={t("App.traders.masters.employees")}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
